import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import TaskStatus from 'components/cards/UserTaskRow/TaskStatus'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import PostIt from 'components/PostIt/PostIt'
import useSession from 'hooks/useSession'
import { useTaskManager } from 'store/hooks'

import styles from './widgets.module.sass'

export const renderTasks = (tasks, i18n, openSingleTask) => {
	return tasks.map((task, index) => {
		return (
			<div key={index} className={styles['task-container']}>
				<HStack
					className={styles['task-entry']}
					columns={['20px', 4, 1]}
					gap='xsmall'
					align='center'
				>
					<div className={styles['task-icon-container']}>
						<Icon
							className={styles['task-icon']}
							width='18px'
							height='18px'
							name={task.icon}
						/>
					</div>
					<div>
						<small>
							<strong>{task.title}</strong>
						</small>
						<div className={styles['task-status-container']}>
							<Tooltip text={task.user?.name || ''}>
								<small
									className={`${styles['assigned-to']} ${
										styles[
											task.assignedToMe ? 'my-task' : ''
										]
									}`}
								>
									{task.assignedTo}
								</small>
							</Tooltip>
							<TaskStatus
								tiny
								className={styles['task-status']}
								status={
									task.isComplete
										? 'complete'
										: task.dueDate?.dueStatus
								}
							/>
							<small>
								{task.dueDate?.dateTimeFormat}{' '}
								{task.status === 'Postponed' &&
									`(${i18n`Postponed`})`}
							</small>
						</div>
					</div>
					<ActionButton
						secondary
						onClick={() => {
							openSingleTask(task)
						}}
					>
						<small>
							<strong>{i18n`Open`}</strong>
						</small>
					</ActionButton>
				</HStack>
				{task.note && (
					<PostIt
						className={styles['note']}
						data={{
							text: task.note,
							placeholder: '1',
							type: 'tooltip',
						}}
					/>
				)}
			</div>
		)
	})
}

export const mapTasks = (tasks, i18n, sessionUser) => {
	return (tasks || []).map((task) => {
		return {
			...task,
			assignedTo:
				task.userId === sessionUser.username
					? i18n`Mine`
					: task.user?.id === 'tanque'
					? i18n`Pool`
					: task.user?.initials || task.userId,
			assignedToMe: task.userId === sessionUser.username,
		}
	})
}

const TasksWidget = (props) => {
	const { data } = props
	const { tasks } = data
	const { i18n } = useGlobal()
	const { openSingleTask } = useTaskManager()
	const { user: sessionUser } = useSession()

	const mappedTasks = mapTasks(tasks, i18n, sessionUser)

	return mappedTasks && mappedTasks.length ? (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='task'
			title={i18n`Tasks`}
			collapsedLabel={mappedTasks.length}
			expanded={true}
			expandable={true}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			{renderTasks(mappedTasks || [], i18n, openSingleTask, sessionUser)}
		</ExpandableWidget>
	) : null
}

export default TasksWidget
